import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="flex justify-center pt-[100px] pb-[70px]">
      <div>
        <h3 className=" text-[12px] md:text-[16px] font-[700] leadin-[14.22px] md:leading-[18.96px] pb-[30px]">
          {" "}
          Follow Us On Social Media{" "}
        </h3>

        <div className="max-w-[185px] mx-auto">
          <div className="flex justify-between">
            <a targe="_blank" href="https://www.facebook.com/shopazhubng/">
              <svg
                width="35"
                height="35"
                viewBox="0 0 35 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M32.8125 17.5923C32.8125 9.13623 25.9561 2.27979 17.5 2.27979C9.04395 2.27979 2.1875 9.13623 2.1875 17.5923C2.1875 25.2349 7.78613 31.5697 15.1074 32.7195V22.0199H11.2185V17.5923H15.1074V14.2188C15.1074 10.3817 17.394 8.26055 20.8913 8.26055C22.5668 8.26055 24.3195 8.55996 24.3195 8.55996V12.3286H22.3877C20.4866 12.3286 19.8919 13.5085 19.8919 14.7212V17.5923H24.1384L23.4603 22.0199H19.8926V32.7209C27.2139 31.5718 32.8125 25.2369 32.8125 17.5923Z"
                  fill="#410636"
                />
              </svg>
            </a>
            <a targe="_blank" href="https://twitter.com/shopazhub">
              <svg
                width="35"
                height="35"
                viewBox="0 0 35 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M33.9062 7.48535C32.6754 8.02016 31.3731 8.37251 30.0405 8.53125C31.441 7.7112 32.4942 6.4084 33.0025 4.86719C31.6785 5.64142 30.2323 6.18466 28.726 6.47363C28.0917 5.80886 27.3288 5.28001 26.4837 4.91924C25.6387 4.55847 24.7291 4.3733 23.8103 4.375C20.0901 4.375 17.0796 7.3418 17.0796 10.999C17.077 11.5077 17.1352 12.0149 17.2532 12.5098C14.5856 12.3847 11.9735 11.7042 9.58397 10.5118C7.19444 9.31938 5.08012 7.64132 3.37627 5.58496C2.77852 6.59266 2.46239 7.74241 2.46094 8.91406C2.46094 11.2109 3.65928 13.2412 5.46875 14.4307C4.39669 14.4052 3.3466 14.1215 2.40762 13.6035V13.6855C2.40762 16.8984 4.73184 19.5713 7.80801 20.1797C7.22954 20.3339 6.63344 20.412 6.03477 20.4121C5.60997 20.4129 5.18613 20.3716 4.76943 20.2891C5.62461 22.9209 8.11357 24.835 11.0619 24.8897C8.66618 26.736 5.72484 27.7339 2.7002 27.7266C2.16331 27.7258 1.62693 27.6938 1.09375 27.6309C4.17073 29.5957 7.74747 30.6349 11.3982 30.625C23.7959 30.625 30.5689 20.5283 30.5689 11.7715C30.5689 11.4844 30.5614 11.1973 30.5478 10.917C31.8624 9.98188 32.9997 8.8198 33.9062 7.48535Z"
                  fill="#410636"
                />
              </svg>
            </a>
            <a targe="_blank" href="https://instagram.com/shopazhubng/">
              <svg
                width="35"
                height="35"
                viewBox="0 0 35 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.4991 12.9438C14.9903 12.9438 12.9429 14.9912 12.9429 17.5C12.9429 20.0088 14.9903 22.0562 17.4991 22.0562C20.0079 22.0562 22.0552 20.0088 22.0552 17.5C22.0552 14.9912 20.0079 12.9438 17.4991 12.9438ZM31.1641 17.5C31.1641 15.6133 31.1812 13.7437 31.0752 11.8604C30.9693 9.67285 30.4703 7.73145 28.8706 6.13184C27.2676 4.52881 25.3296 4.03321 23.1421 3.92725C21.2554 3.82129 19.3858 3.83838 17.5025 3.83838C15.6158 3.83838 13.7461 3.82129 11.8628 3.92725C9.67533 4.03321 7.73393 4.53223 6.13432 6.13184C4.53129 7.73486 4.03568 9.67285 3.92973 11.8604C3.82377 13.7471 3.84086 15.6167 3.84086 17.5C3.84086 19.3833 3.82377 21.2563 3.92973 23.1397C4.03568 25.3272 4.53471 27.2686 6.13432 28.8682C7.73734 30.4712 9.67533 30.9668 11.8628 31.0728C13.7496 31.1787 15.6192 31.1616 17.5025 31.1616C19.3892 31.1616 21.2588 31.1787 23.1421 31.0728C25.3296 30.9668 27.271 30.4678 28.8706 28.8682C30.4737 27.2651 30.9693 25.3272 31.0752 23.1397C31.1846 21.2563 31.1641 19.3867 31.1641 17.5ZM17.4991 24.5103C13.6197 24.5103 10.4888 21.3794 10.4888 17.5C10.4888 13.6206 13.6197 10.4897 17.4991 10.4897C21.3785 10.4897 24.5093 13.6206 24.5093 17.5C24.5093 21.3794 21.3785 24.5103 17.4991 24.5103ZM24.7964 11.8398C23.8907 11.8398 23.1592 11.1084 23.1592 10.2026C23.1592 9.29688 23.8907 8.56543 24.7964 8.56543C25.7022 8.56543 26.4336 9.29688 26.4336 10.2026C26.4339 10.4177 26.3917 10.6307 26.3096 10.8295C26.2274 11.0282 26.1068 11.2088 25.9547 11.3609C25.8026 11.513 25.622 11.6336 25.4233 11.7158C25.2245 11.798 25.0115 11.8401 24.7964 11.8398Z"
                  fill="#410636"
                />
              </svg>
            </a>

            <a
              target="_blank"
              href="https://www.tiktok.com/@shopazhubng?is_from_webapp=1&sender_device=pc"
            >
              <svg
                width="35"
                height="35"
                viewBox="0 0 35 35"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M28.176 8.11152C27.9545 7.99706 27.7389 7.87157 27.53 7.73555C26.9224 7.33391 26.3654 6.86065 25.8709 6.32598C24.6336 4.91025 24.1715 3.47402 24.0012 2.46846H24.0081C23.8659 1.63379 23.9247 1.09375 23.9336 1.09375H18.298V22.8854C18.298 23.1779 18.298 23.4671 18.2857 23.7528C18.2857 23.7884 18.2823 23.8212 18.2803 23.8595C18.2803 23.8752 18.2803 23.8916 18.2768 23.908V23.9203C18.2174 24.7022 17.9668 25.4575 17.547 26.1198C17.1271 26.7821 16.551 27.331 15.8692 27.7184C15.1587 28.1226 14.355 28.3347 13.5375 28.3336C10.9118 28.3336 8.78377 26.1926 8.78377 23.5484C8.78377 20.9043 10.9118 18.7633 13.5375 18.7633C14.0345 18.7628 14.5285 18.841 15.0011 18.995L15.0079 13.2569C13.5733 13.0716 12.1158 13.1856 10.7275 13.5918C9.33913 13.9979 8.05003 14.6874 6.94148 15.6167C5.97014 16.4607 5.15353 17.4677 4.5284 18.5924C4.29051 19.0025 3.39295 20.6507 3.28426 23.3256C3.2159 24.8439 3.67185 26.4168 3.88924 27.0669V27.0806C4.02596 27.4634 4.55574 28.7697 5.41912 29.871C6.11532 30.7544 6.93785 31.5304 7.86023 32.174V32.1604L7.8739 32.174C10.6021 34.0279 13.627 33.9063 13.627 33.9063C14.1507 33.8851 15.9048 33.9063 17.8968 32.9622C20.1061 31.9156 21.3639 30.3564 21.3639 30.3564C22.1675 29.4247 22.8065 28.3629 23.2534 27.2166C23.7634 25.8761 23.9336 24.2683 23.9336 23.6257V12.0647C24.0019 12.1058 24.9125 12.708 24.9125 12.708C24.9125 12.708 26.2243 13.5488 28.271 14.0964C29.7393 14.486 31.7177 14.5681 31.7177 14.5681V8.97354C31.0245 9.04873 29.617 8.82998 28.176 8.11152Z"
                  fill="#410636"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
